module.exports = __webpack_public_path__ + "static/media/feat-curtains-img1.e2205f3c.jpg";